module.exports = __webpack_public_path__ + "img/default-logo.cdda9bd6.png";